const handleResponse = async (givenPromise, onSuccess, onError) => {
  try {
    const value = await givenPromise;
    onSuccess(value);
  } catch (error) {
    onError(error);
  }
};

export default handleResponse;
